import React, { FC } from 'react'
import { SVGProps } from './types'

export const DownloadTwo: FC<SVGProps> = ({
  size = 24,
  onClick,
  color = '#323232',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
    >
      <path d="M12 4v7M6 11l6 6 6-6M6 20h12" />
    </svg>
  )
}
